import React, { useEffect, useMemo, useState } from "react";

import AntdPagination from "antd/es/pagination";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import Dated from "@mapmycustomers/shared/types/base/Dated";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import Named from "@mapmycustomers/shared/types/base/Named";
import User from "@mapmycustomers/shared/types/User";

import SortField from "@app/component/ListDrawer/enum/SortField";
import getFilteredSavedFilters from "@app/util/getFilteredSavedFilters";

import styles from "./Footer.module.scss";

const PAGE_SIZE = 20;

interface Props<T> {
  creatorIds: User["id"][];
  field: SortField;
  items: T[];
  onChangePage: (data: T[]) => void;
  order: SortOrder;
  search: string;
}

const Footer = <T extends Identified & Named & Dated<Date>>({
  creatorIds,
  field,
  items,
  onChangePage,
  order,
  search,
}: Props<T>) => {
  const [currentPage, setCurrentPage] = useState(1);

  const sortedFilters = useMemo(
    () => getFilteredSavedFilters(search, items, field, order, creatorIds),
    [creatorIds, field, items, order, search]
  );

  const preparedRows = useMemo(() => {
    const filtersPerPage = sortedFilters.slice(
      (currentPage - 1) * PAGE_SIZE,
      currentPage * PAGE_SIZE
    );

    return filtersPerPage;
  }, [sortedFilters, currentPage]);

  useEffect(() => {
    onChangePage(preparedRows);
  }, [preparedRows, onChangePage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [sortedFilters.length]);

  return (
    <div className={styles.footer}>
      <AntdPagination
        className={styles.paginationContainer}
        current={currentPage}
        defaultPageSize={PAGE_SIZE}
        onChange={setCurrentPage}
        showSizeChanger={false}
        total={sortedFilters.length}
      />
    </div>
  );
};

export default Footer;
